import { render, staticRenderFns } from "./ReviewOfPacking.vue?vue&type=template&id=1fbec3da"
import script from "./ReviewOfPacking.vue?vue&type=script&lang=js"
export * from "./ReviewOfPacking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports